"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _PaymentCalculatorModalModule = _interopRequireDefault(require("./PaymentCalculatorModal.module.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

var _calc = _interopRequireDefault(require("@wisetack/assets/img/calc.svg"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var PaymentCalculatorEstimatedModal = function PaymentCalculatorEstimatedModal() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("modal fade", _PaymentCalculatorModalModule["default"].modal),
    id: "paymentCalculatorEstimatedModal",
    tabIndex: "-1",
    role: "dialog",
    "aria-labelledby": "calculatorEstimatedLabel",
    "aria-hidden": "false"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("modal-dialog", _PaymentCalculatorModalModule["default"].modalDialog),
    role: "document"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("modal-content", _PaymentCalculatorModalModule["default"].modalContent)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-header"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "close",
    "data-test-id": "close-paymentCalculatorModal",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _PaymentCalculatorModalModule["default"].close,
    "aria-hidden": "true"
  }, "\xD7"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("modal-body", _PaymentCalculatorModalModule["default"].modalBody)
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: _PaymentCalculatorModalModule["default"].logo,
    src: _calc["default"],
    alt: "calc-logo"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      textAlign: "left"
    }
  }, "The interest rates, payment amounts, and total interest are estimates only. If you are approved for a Wisetack loan, the actual interest rate, payment amount, and total interest will be provided to you before you sign the\xA0loan\xA0agreement.")))));
};

var _default = PaymentCalculatorEstimatedModal;
exports["default"] = _default;